<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="fmtx1">
    For Katrina, my love, who sees things whole
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// john_9781571318169_oeb_ded_r1.vue?6133aab2